import { IntegrityMonitorPolicyRuleSetsSectionWebComponent } from './component/IntegrityMonitorPolicyRuleSetsSectionWebComponent';
import { WEB_COMPONENT_INTEGRITY_MONITOR_POLICY_RULE_SETS_SECTION } from '../../../../webcomponents.constants';

export { IntegrityMonitorPolicyRuleSetsSectionWebComponent };

window.customElements.define(
  WEB_COMPONENT_INTEGRITY_MONITOR_POLICY_RULE_SETS_SECTION,
  IntegrityMonitorPolicyRuleSetsSectionWebComponent
);
